import React, { useSelector } from "react-redux";
import Stopper from "@/components/stopper/Stopper";
// import CustomLink from "@/bit/components/react-components.custom-link";

const Core = ({ children }) => {
  const handlingCode = useSelector((state) => state.initPage.handlingCode);

  return (
    <div>
      {handlingCode < 0 && <Stopper handlingCode={handlingCode} />}
      {handlingCode === 0 && children}
    </div>
  );
};
export default Core;
